<template>
    <canvas ref="chart" width="100" height="100" />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { Chart, type TooltipItem } from "./chart";

const chart = ref<HTMLCanvasElement | null>(null);
const parameters: any = {
    type: "bar",
    data: {
        labels: ["Glucosamine", "Placebo"],
        datasets: [
            {
                label: "% Pain Reduction",
                data: [19, 33],
                backgroundColor: [
                    "rgba(192, 0, 0, 0.7)",
                    "rgba(24, 140, 251, 0.7)",
                ],
                borderColor: ["rgba(192, 0, 0, 1)", "rgba(24, 140, 251, 1)"],
                borderWidth: 1,
            },
        ],
    },
    options: {
        scales: {
            x: {
                ticks: {
                    color: "#ffffff",
                },
                grid: {
                    borderColor: "rgba(255, 255, 255, 0.5)",
                    color: "rgba(255, 255, 255, 0.2)",
                },
            },
            y: {
                beginAtZero: true,
                grid: {
                    borderColor: "rgba(255, 255, 255, 0.5)",
                    color: "rgba(255, 255, 255, 0.2)",
                },
                ticks: {
                    color: "#ffffff",
                    callback: function (value: number | string) {
                        return value + "%";
                    },
                },
                title: {
                    color: "#ffffff",
                },
            },
        },
        plugins: {
            legend: {
                labels: {
                    color: "#ffffff",
                },
            },
            tooltip: {
                callbacks: {
                    label: function (context: TooltipItem<"bar">) {
                        return `${context.formattedValue}%`;
                    },
                },
            },
        },
    },
};

onMounted(() => {
    if (chart.value) {
        new Chart(chart.value, parameters);
    }
});
</script>
